import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Injectable({ providedIn: 'root' })

export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // El token es lo que decide, no `currentUserValue`: ese sale de
        // `JSON.parse(localStorage.getItem('currentUser') || '{}')` y sin sesión
        // devuelve `{}`, que es truthy. Dando por buena esa sesión vacía el portal
        // arrancaba completo, pedía datos sin token, el 401 recargaba la página y
        // el usuario veía blanco durante varios arranques del bundle antes de caer
        // al login. Se mira localStorage directo —como hace GroupGuard— porque
        // `authenticationService.token` se captura en el constructor y se queda viejo.
        const token = localStorage.getItem('token');
        if (token) {
            // user logged
            return true;
        }

        // user not logged redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}
